import React, { forwardRef } from "react";
import { TradeRocketSvg } from "./TradeRocketSvg";

export const OrderTimeMarkersLayer = forwardRef(function OrderTimeMarkersLayer(
  { visibleOrderTimeMarkers = [] },
  ref,
) {
  return (
    <div
      ref={ref}
      className="order-time-marker-layer"
      aria-hidden="true"
    >
      {visibleOrderTimeMarkers.map((marker) => (
        <div
          key={marker.id}
          className="order-time-segment"
          data-tone={marker.tone === "down" ? "down" : "up"}
          data-marker-id={marker.id}
          style={{
            left: `${marker.startX}px`,
            width: `${Math.max(0, marker.endX - marker.startX)}px`,
            top: `${14 + marker.index * 18}px`,
          }}
        >
          <div className="order-time-segment__rocket" aria-hidden="true">
            <TradeRocketSvg tone={marker.tone === "down" ? "down" : "up"} />
          </div>
          <div className="order-time-segment__finish" aria-hidden="true">
            <div className="order-time-segment__finish-beacon" />
          </div>
        </div>
      ))}
    </div>
  );
});

